import { Submission } from '@interhyp/module-credit';
import React, { useMemo } from 'react';

import { COMMUNICATION_PLUGIN_ENABLED } from '../../../constants/env';
import { Navigation, NavItems } from '../../navigation/Navigation';

import '@interhyp/shared-credit/esm/index.css';
import '@interhyp/module-credit/esm/index.css';

export interface SubmissionOverviewLegacyWrapperProps {
  submissionId: string;
  providerId: string;
  currentUserId: string;
  caseId: string;
}

export function SubmissionOverviewLegacyWrapper({
  currentUserId,
  providerId,
  caseId,
  submissionId,
}: SubmissionOverviewLegacyWrapperProps): JSX.Element {
  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/credit/summary`, translation: 'navigation.summary' },
      { to: `/credit/documents`, translation: 'navigation.documents' },
      ...(COMMUNICATION_PLUGIN_ENABLED
        ? [
            {
              to: `/credit/communication`,
              translation: 'navigation.communication',
            },
          ]
        : []),
    ];
  }, []);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <Submission
        submissionId={submissionId}
        providerId={providerId}
        currentUserId={currentUserId}
      />
    </>
  );
}
